import * as CryptoJS from 'crypto-js';
import * as forge from 'node-forge';

export class EncryptUtil {

  private static readonly PUBLICKEY = "-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1440RYgGusU6CIApQUX2\nFgAPNMnOEZpYUycZCpx4C9qytskVNXL6MXfOsHB2yzJyZ9Z4/VzIBCifTZc+CK98\ntSuA3X3eWois5xR309ShvlBLQuH6o9dv4X3tpRjIiLdyCHjKu4+UR8PBkt2K+pbO\nYWeLq6jXIKzniarb4c4bf8UzIHVKgie4uNeJHgAhpvNAeMMt+DfaLXTpbMCpdhAj\nD3F18bqqVwhyEx1HVXn6TEHfQ6/KmGkPjuPQ++YUxMyerEOYvBUTEam4U173F4Sv\nVs86Q9+gPYBhXhaqeAIm11dA1tglDVaduK+bQbhHFUI9FK7z/gn3+zHwTiZ6pNMr\nRwIDAQAB\n-----END PUBLIC KEY-----";

    static generateSaltAndIv(): any {
      const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
      const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
      return {
        "iv": iv,
        "salt": salt,
      }
    }

    

    static encryptAES(phrasevalue: string, passPhrase: string, iv: string, salt: string): any {
      if(phrasevalue == "") {
        return {
          "phrasevalue": "",
          "iv": "",
          "salt": "",
          "ciphertext": ""
        };
      }
      const ciphertext = this.aesEncrypt(salt, iv, passPhrase, phrasevalue, 128, 1000);
      const aesphrasevalue = iv + "::" + salt + "::" + ciphertext;
      return {
        "phrasevalue": aesphrasevalue,
        "iv": iv,
        "salt": salt,
        "ciphertext": ciphertext
      };
    }
  
    static aesEncrypt(salt: string, iv: string, passPhrase: string, plainText: string, size: number, iteration: number) {
      const keySize = size / 32;
      const key = this.aesGenerateKey(salt, passPhrase, keySize, iteration);
      const encrypted = CryptoJS.AES.encrypt(
        plainText,
        key,
        { iv: CryptoJS.enc.Hex.parse(iv), padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }
  
    static aesGenerateKey(salt: string, passPhrase: string, keySize: number, iterationCount: number){
      const key = CryptoJS.PBKDF2(
        passPhrase,
        CryptoJS.enc.Hex.parse(salt),
        { 
          keySize: keySize, 
          iterations: iterationCount, 
          hasher: CryptoJS.algo.SHA256,});
      return key;
    }

    static decryptAES(encryptedText: string, passPhrase: string, iv: string, salt: string) {
      if (encryptedText == "") return "";
      const keySize = 128 / 32;
      const iterations = 1000;
      const key = this.aesGenerateKey(salt, passPhrase, keySize, iterations);
    
      const decrypted = CryptoJS.AES.decrypt({
        ciphertext: CryptoJS.enc.Base64.parse(encryptedText)
      } as any,key,
        { 
          iv: CryptoJS.enc.Hex.parse(iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7, 
        },
      );
      const res = decrypted.toString(CryptoJS.enc.Utf8);
      return res;
      // final int keySize = 128 ~/ 32;
      // final key = _aesGenerateKey(salt, passPhrase, keySize, 1000);
      // final enc = Encrypter(AES(key, mode: AESMode.cbc, padding: "PKCS7")); // Asegurar PKCS7 Padding
  
      // final Uint8List encryptedBytes = base64.decode(encryptedText); // Decodificar correctamente el texto cifrado
      // final decrypted = enc.decrypt(
      //   Encrypted(encryptedBytes),
      //   iv: IV(Uint8List.fromList(hex.decode(iv))),
      // );
  
      // return decrypted;
    }




  /*static encryptAES(strToEncrypt: string, key: string): string {
    return this.aesEncrypt('823e00ab56f34931d1d7ead9ed0e5365', '0a29af5fcfc02c174db05a0fb275a7db', key, strToEncrypt, 128, 1000);
  }

  static aesGenerateKey(salt: string, passPhrase: string, keySize: number, iterationCount: number): CryptoJS.lib.WordArray {
    return CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: keySize / 32, // keySize en palabras (32 bits por palabra)
        iterations: iterationCount,
        hasher: CryptoJS.algo.SHA1
    });
  }

  
  
  static aesEncrypt(salt: string, iv: string, passPhrase: string, plainText: string, size: number, iteration: number): string {
      const key = this.aesGenerateKey(salt, passPhrase, size, iteration);
      const ivWordArray = CryptoJS.enc.Hex.parse(iv);
  
      const encrypted = CryptoJS.AES.encrypt(plainText, key, {
          iv: ivWordArray,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });
  
      return btoa(encrypted.toString());
  }*/

  /*static encryptAES(strToEncrypt: string, key: string): string {
    const iv = CryptoJS.enc.Hex.parse('0a29af5fcfc02c174db05a0fb275a7db');
    const salt = CryptoJS.enc.Hex.parse('823e00ab56f34931d1d7ead9ed0e5365');

    const derivedKey = this.generateKey(salt, key);
    const encrypted = CryptoJS.AES.encrypt(strToEncrypt, derivedKey, {
        keySize: 128,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    return `${iv.toString(CryptoJS.enc.Hex)}::${salt.toString(CryptoJS.enc.Hex)}::${btoa(encrypted.toString())}`;
  }

  static generateKey(salt: CryptoJS.lib.WordArray, passphrase: string): CryptoJS.lib.WordArray {
    return CryptoJS.PBKDF2(passphrase, salt, {
        keySize: 128,
        iterations: 1000,
        hasher: CryptoJS.algo.SHA1,
    });
  }*/

  // RSA Encryption
  public static encryptRSA(plainText: string): string {
    const publicKey = forge.pki.publicKeyFromPem(EncryptUtil.PUBLICKEY);
    const encodedText = forge.util.encodeUtf8(plainText);
    const encryptedBytes = publicKey.encrypt(encodedText, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: {
        md: forge.md.sha1.create()
      }
    });
    return forge.util.encode64(encryptedBytes);
  }

  // RSA Decryption
  public static decryptRSA(cipherText: string, privateKeyValue: string): string {
    const privateKey = forge.pki.privateKeyFromPem(privateKeyValue);
    const decodedCipherText = forge.util.decode64(cipherText);
    const decrypted = privateKey.decrypt(decodedCipherText, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: forge.mgf.mgf1.create
    });

    return decrypted;
  }
}
